<template>
  <!-- 登录弹框 -->
  <section class="container LoginM">
    <el-dialog
      :visible.sync="$store.state.Login.login"
      lock-scroll
      :close-on-click-modal="modalclick"
      width="360px"
    >
      <div class="cancel" @click="cancel">关闭</div>
      <div class="loginM">
        <div class="header text-center">登录</div>
        <div class="tel">
          <Input
            v-model="account"
            placeholder="请输入您的账号"
            style="width: 100%"
          />
        </div>
        <div class="password">
          <Input
            v-model="password"
            type="password"
            placeholder="请输入密码"
            style="width: 100%"
          />
        </div>
        <div class="tip flex-row">
          <div class="text-left col-50">
            <!--<span class="pointer" @click="$store.state.Login.login = false;$store.state.Login.pwdSetting = true">修改密码</span>-->
          </div>
          <div class="text-right col-50">
            <!--<span class="pointer" @click="$store.state.Login.login = false;$store.state.Login.forget = true">忘记密码？</span>-->
          </div>
        </div>
        <div class="login-btn">
          <el-button
            :loading="loading"
            :disabled="disabled"
            @click="login"
            plain
            >登录</el-button
          >
        </div>
      </div>
    </el-dialog>
    <!--<el-dialog-->
    <!--:visible.sync="$store.state.Login.forget"-->
    <!--lock-scroll-->
    <!--width="360px"-->
    <!--&gt;-->
    <!--<div class="loginM">-->
    <!--<div class="header text-center">-->
    <!--忘记密码-->
    <!--</div>-->
    <!--<div class="tel">-->
    <!--<Input v-model="mobile" placeholder="请输入您的手机号码" style="width: 100%" />-->
    <!--</div>-->
    <!--<div class="password flex-row">-->
    <!--<div class="col-60 pwd2">-->
    <!--<Input v-model="code" placeholder="请输入验证码" style="width: 100%" />-->
    <!--</div>-->
    <!--<div class="col-40 code  pointer text-center" @click="timeClick">-->
    <!--{{msg}}-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="password">-->
    <!--<Input v-model="newPassword" type="password" placeholder="请输入新密码" style="width: 100%" />-->
    <!--</div>-->
    <!--<div class="password">-->
    <!--<Input v-model="newPassword1" type="password" placeholder="请再次输入新密码" style="width: 100%" />-->
    <!--</div>-->
    <!--<div class="tip flex-row">-->
    <!--<div class="text-left col-50">-->
    <!--&lt;!&ndash;<span class="pointer" @click="$store.state.Login.forget = false;$store.state.Login.pwdSetting = true">修改密码</span>&ndash;&gt;-->
    <!--</div>-->
    <!--<div class="text-right col-50">-->
    <!--<span class="pointer" @click="$store.state.Login.forget = false;$store.state.Login.login = true">登录</span>-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="login-btn">-->
    <!--<el-button :loading="loading" :disabled="disabled" @click="" plain>确定</el-button>-->
    <!--</div>-->
    <!--</div>-->
    <!--</el-dialog>-->
    <Modal
      v-model="$store.state.alertExam"
      title="考试资格提醒"
      ok-text="立即预约"
      cancel-text="下次预约"
      @on-ok="joinExam"
      @on-cancel="close"
    >
     <!-- 能力提高班  -->
      <p v-if="$store.state.subjectCode == 2">
       您当前已具备考试资格，是否预约考试？
        （能力提高班学习及考试时间共为30天，可根据个人时间以及知识掌握程度，进行预约考试。
        预约考试后，请在预约后的第二日进行考试。考试前请仔细阅读学习指南中的考试要求，
        如正考未通过，则有一次补考机会。请谨慎预约考试）
      </p>
      <!-- 运维培训 -->
      <p v-if="$store.state.subjectCode == 3">
        您当前已具备考试资格，是否预约考试？（
        运维培训的学习及考试时间共为15天，可根据个人时间以及知识掌握程度，进行预约考试。
        预约后，请在约考后的第二日进行考试。如考试未通过，无需再次预约考试，
        根据个人情况参加补考即可）
      </p>
      <!-- 工程经理 -->
      <p v-if="$store.state.subjectCode == 1">
        您当前已经具备考试资格，是否预约考试？
        （预约成功后，将安排考试时间，如有特殊原因不能参加考试，需在考试开始前
        24小时与工作人员联系取消考试，否则将视为缺考，成绩计为“0”，参加补考；
        每位学员两次补考机会，请谨慎确定预约考试。）
      </p>
      <!-- 职称继教 -->
      <p
        v-if="
          $store.state.subjectCode == 4 ||
          $store.state.subjectCode == 5 ||
          $store.state.subjectCode == 6
        "
      >
        您当前已具备考试资格，是否预约考试？（完成预约后，点击导航栏“在线考试”，登录即可）
      </p>
    </Modal>
  </section>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      modal1: true,
      account: "",
      password: "",
      loading: false,
      disabled: false,
      mobile: "",
      code: 0, //考试课程id
      time: 60,
      newPassword: "",
      newPassword1: "",
      modalclick: true,
    };
  },
  computed: {
    msg() {
      if (this.time >= 60) {
        return "获取验证码";
      } else {
        return "剩余" + this.time + "秒";
      }
    },
  },
  methods: {
    timeCount() {
      var that = this;
      if (that.time > 1) {
        that.time--;
        setTimeout(function () {
          that.timeCount();
        }, 1000);
      } else {
        that.time = 60;
      }
    },
    timeClick() {
      if (this.time < 60) {
        return false;
      }
      this.timeCount();
    },
    login() {
      var that = this;
      that.loading = true;
      that.disable = true;
      var modelData = {
        account: that.account,
        password: that.password,
      };
      this.$http({
        url: that.webhost + "login",
        method: "POST",
        data: modelData,
      }).then(({ data }) => {
        that.loading = false;
        that.disable = false;
        if (data && data.code === 0) {
          var tmp = data.data.user;
          if (tmp.headImg == "") {
            tmp.headImg = null;
          }
          that.$store.commit("getUser", tmp);
          that.$cookie.set("xjaf-user", JSON.stringify(tmp));
          that.$cookie.set("xjaf-token", data.data.token);
          that.$store.state.Login.login = false;
          that.$store.state.isLogin = true;
          that.$Message.success("登录成功!");
          that
            .$http({
              url: that.webhost + "user/checkStandard",
              method: "GET",
            })
            .then(({ data }) => {
              if (data != 0 && data.code === 0 && data.data != 0) {
                that.$store.commit("setAlertExam");
                that.$store.commit("setSubjectCode", data.data);
              }
            });
          //需要token的页面 重新初始化父组件的初始化函数
          this.$emit("loadtoken");
        } else {
          that.$Message.error(data.msg);
        }
      });
    },
    close() {
      console.log("关闭预约");
    },
    joinExam() {
      console.log(this.$store.state.user.idCard, 888);
      // return
      var that = this;
      if (that.$store.state.subjectCode != 0) {
        var nameData = {
          idCard: this.$store.state.user.idCard,
          subjectCode: that.$store.state.subjectCode,
          orderCode: 1,
        };
        console.log(nameData, 7878787);

        this.$http({
          url: that.webhost + "/userOrderTime/save",
          method: "POST",
          data: nameData,
        }).then(({ data }) => {
          if (data && data.code === 0) {
            that.$Notice.success({
              title: "考试预约提您已成功预约考试，管理员会醒",
              // desc:'尽快为您安排考试',
              duration: 5,
              render: (h) => {
                return h(
                  "span",
                  {
                    style: {
                      color: "#0056a1",
                      fontSize: "15px",
                    },
                  },
                  ["您已成功预约考试，管理员会尽快为您安排考试。"]
                );
              },
            });
          } else {
            that.$Message.error(data.msg);
          }
        });
        // if (that.$store.state.subjectCode != 0) {
        //   this.$http({
        //     url: that.webhost + "user/joinExam/" + that.$store.state.subjectCode,
        //     method: "GET"
        //   }).then(({ data }) => {
        //     console.log(data, 9999888);

        //     if (data && data.code === 0) {
        //       that.$Notice.success({
        //         title: "考试预约提醒",
        //         // desc:'您已成功预约考试，管理员会尽快为您安排考试',
        //         duration: 5,
        //         render: h => {
        //           return h(
        //             "span",
        //             {
        //               style: {
        //                 color: "#0056a1",
        //                 fontSize: "15px"
        //               }
        //             },
        //             ["您已成功预约考试，管理员会尽快为您安排考试。"]
        //           );
        //         }
        //       });
        //     } else {
        //       that.$Message.error(data.msg);
        //     }
        //   });
        // }
      }
    },
    set() {
      var that = this;
      that.loading = true;
      that.disable = true;
      var modelData = {
        account: that.account,
        password: that.password,
      };
      this.$http({
        url: that.webhost + "login",
        method: "POST",
        data: modelData,
      }).then(({ data }) => {
        that.loading = false;
        that.disable = false;
        if (data && data.code === 0) {
          console.log(data.data);
          // that.bannerList = data.data;
        } else {
          // that.$toast.error(data.msg)
        }
      });
    },
    forget() {
      var that = this;
      that.loading = true;
      that.disable = true;
      var modelData = {
        account: that.account,
        password: that.password,
      };
      this.$http({
        url: that.webhost + "login",
        method: "POST",
        data: modelData,
      }).then(({ data }) => {
        that.loading = false;
        that.disable = false;
        if (data && data.code === 0) {
          console.log(data.data);
          // that.bannerList = data.data;
        } else {
          // that.$toast.error(data.msg)
        }
      });
    },
    cancel() {
      this.$store.commit("out");
    },
  },
  components: {},
};
</script>

<style>
.LoginM .el-dialog__header {
  display: none;
}
.LoginM .el-dialog {
  background: transparent;
}
.LoginM .el-dialog__body {
  background: #1b7bc0;
  position: relative;
}
.loginM {
  padding: 20px 30px 70px;
  color: #fff;
}
.loginM .header {
  font-size: 22px;
  line-height: 70px;
}
.password {
  margin-top: 25px;
}
.loginM input {
  outline: none;
  border: none;
}
.tip {
  margin-top: 15px;
  font-size: 12px;
}
.login-btn {
  margin-top: 25px;
}
.login-btn button {
  width: 100%;
  height: 32px;
  line-height: 32px;
  padding: 0 12px;
}
.password .code {
  height: 32px;
  line-height: 32px;
  color: #fff;
  background: #23b8ff;
}
.pwd2 input {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.cancel {
  color: #ffffff;
  right: 10px;
  text-align: right;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/components/Login.vue